import React, { useEffect, useState, useRef } from 'react';
import WorkPlanForm from './workplanForm';
import SimpleDialog from './simpleDialog';
import axios from 'axios';
import { translate } from 'react-i18next';
import { withStyles, Paper } from '@material-ui/core';
import CustomButton from '../../../../common/components/UI/Button/Button';
import SideBar from '../../../../common/components/UI/SideBar/SideBar';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from '@fortawesome/pro-solid-svg-icons';
import { connect } from 'react-redux';
import {
	updateMAINworkPlans, updateSpinnerShow, updateSelectedWorkPlan, updateUrlKronos, updateSettingsList,
	updateActionWorkplanList, updateSnackbar, updateShowRightPanelList,
} from '../actions';
import Snackbar from '../../UI/Snackbar/Snackbar';
import { exists, currentHttpOptions } from '../../../../common/utilities/utilitiesFunctions';
import { handleAPIErrors } from '../../../auxilaries';
import './workplanList.scss';
import FilterSelectionBar from '../../FilterSelectionBar';
import { handleSort, genOrgPath } from './workPlanList.service';
import { WorkplanCurrentStatus } from '../../../Enums/Status';
import { useWindowDimensions } from '../../hooks/index';
import CustomToolTip from '../../../../common/components/UI/ToolTip/ToolTip';
import WorkPlanListTable from './workPlanListTable';
import _ from 'lodash';

const styles = _ => ({
	icon: {
		paddingRight: "10px"
	},
	SideBar: {
		minWidth: '420px'
	},
});

function WorkPlanList({
	actionWorkplanList,
	refreshAdmin,
	MAINworkPlans,
	classes,
	dateFormat,
	settingsList,
	updateSettingsList,
	updateSelectedWorkPlan,
	updateShowRightPanelList,
	updateActionWorkplanList,
	updateMAINworkPlans,
	updateSnackbar,
	updateSpinnerShow,
	selectedWorkPlan,
	showRightPanelList,
	snackbar,
	...props
}) {
	const { t: translate } = props;
	const t = (prop) => translate(`workplanManager:workPlanList.${prop}`);
	const [showDeleteDialog, setShowDeleteDialog] = useState(false);
	const [workplanIdToDelete, setWorkplanIdToDelete] = useState('');
	const [workplanNameToDelete, setWorkplanNameToDelete] = useState('');
	const [searchValue, setSearchValue] = useState('');
	const [statusFilterSelected, setStatusFilterSelected] = useState([]);
	const [filteredWorkPlans, setFilteredWorkPlans] = useState([]);
	const [sortValues, setSortValues] = useState({ sortColumn: '', sortType: 'asc' });
	const height = useWindowDimensions().height - 200;
	const ref = useRef(null);
	const rightPanelTitle = () => {
		switch (actionWorkplanList) {
			case 'Edit':
				return {
					title: t('form.editCurrent'),
					icon: <FontAwesomeIcon color="#0A54A2" icon={['far', 'edit']} />
				};
			case 'Duplicate':
				return {
					title: t('form.duplicateCurrent'),
					icon: <FontAwesomeIcon color="#0A54A2" icon={['far', 'clone']} />
				};
			case 'Create':
				return {
					title: t('form.titleCreate'),
					icon: <FontAwesomeIcon color="#0A54A2" icon={['far', 'layer-plus']} size="1x" />
				}
			default:
				return '';
		}
	};
	const sideBarTitle = actionWorkplanList ? rightPanelTitle() : '';

	useEffect(() => {
		const getWorkPlans = async () => {
			try {
				let [
					resWorkplans,
					settingsList
					] = await Promise.all([
						axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/GetWorkplans', currentHttpOptions()),
						axios.get(process.env.REACT_APP_DOTNET_URL + '/api/v1/admin/GetSettingsForManager', currentHttpOptions())
					]);

				resWorkplans.data = resWorkplans.data.map(wp => {
					const currentStatus = wp.states.find(status => status.isCurrent);

					if (exists(currentStatus)) {
						wp.currentStatus = { ...wp.currentStatus, effectiveDate: currentStatus.effectiveDate, endDate: currentStatus.endDate };
					}
					else if (wp.status === 1) {
						wp.currentStatus = { ...wp.currentStatus, effectiveDate: wp.startDate, endDate: wp.endDate };
					}
					else {
						wp.currentStatus = { ...wp.currentStatus, effectiveDate: 0, endDate: 0 };
					}

					return { ...wp, length: wp.periodLength * (wp.periodType === "Weeks" ? 7 : 1) };
				});
				
				settingsList = settingsList.data.map(setting => { return { ...setting, value: setting.id, label: setting.name } });
				updateMAINworkPlans(resWorkplans.data);
				setFilteredWorkPlans(MAINworkPlans);
				updateSettingsList(settingsList);
				updateSpinnerShow(false);
			} catch (ex) {
				let errorMessage = handleAPIErrors(ex.response);
				updateSnackbar({
					typeSnackbar: 'error',
					messageSnackbar: errorMessage,
					openSnackbar: true,
				});
			}
		}
		updateSpinnerShow(true);
		getWorkPlans();
	}, []);

	useEffect(() => {
		handleSort(filteredWorkPlans, setFilteredWorkPlans, sortValues.sortColumn, sortValues.sortType);
	}, [JSON.stringify(sortValues)]);

	useEffect(() => {
		handleFilter();
	}, [searchValue, JSON.stringify(statusFilterSelected), JSON.stringify(MAINworkPlans)]);

	const searchableWorkPlan = (workPlan) => `
		 ${workPlan.name}
        |${workPlan.description}
        |${workPlan.currentStatus.label}
		|${workPlan.jobs.map((job) => job.orgPath).join('')}
		|${`${workPlan.periodLength} ${workPlan.periodType}`}
        `.toLocaleLowerCase();

	const handleFilter = () => {
		let filteredWorkplans = _.cloneDeep(MAINworkPlans);
		if (!searchValue && !statusFilterSelected.length) {
			setFilteredWorkPlans(filteredWorkplans);
		}

		if (searchValue) {
			filteredWorkplans = filteredWorkplans.filter((workplan) => searchableWorkPlan(workplan).includes(searchValue.toLocaleLowerCase()));
		}
		if (statusFilterSelected.length) {
			filteredWorkplans = filteredWorkplans.filter((workplan) => statusFilterSelected.includes(workplan.currentStatus.value));
		}
		setFilteredWorkPlans(filteredWorkplans);
	};
	const closeSnackbar = () => {
		updateSnackbar({ typeSnackbar: '', messageSnackbar: '', openSnackbar: false });
	}
	const deleteWorkPlan = () => {
		updateSpinnerShow(true);
		setShowDeleteDialog(false);
		axios.delete(process.env.REACT_APP_DOTNET_URL + '/api/v1/manager/workplan/DeleteWorkPlan/' + workplanIdToDelete, currentHttpOptions()).then(() => {
			const filteredMAINworkPlans = MAINworkPlans.filter((mp) => mp.workplanId !== workplanIdToDelete);
			updateMAINworkPlans(filteredMAINworkPlans);
			setWorkplanIdToDelete('');
		}).catch(ex => {
			// updateSpinnerShow(false);
			let errorMessage = handleAPIErrors(ex.response);

			updateSnackbar({
				typeSnackbar: 'error',
				messageSnackbar: errorMessage,
				openSnackbar: true,
			});
		});
	};

	const cancelAction = (e) => {
		updateShowRightPanelList(false);
		setShowDeleteDialog(false);
		e.stopPropagation();
	};

	const clickAddWorkplan = () => {
		updateActionWorkplanList('CreateWorkplan');
		updateShowRightPanelList(true);
	};

	const closeRightPanel = () => {
		updateShowRightPanelList(false);
	};

	const header = (
		<div className='workplanList-header-container'>
			<CustomButton
				color={'primary'}
				onClick={clickAddWorkplan}
				icon={faPlusCircle}
				className={'workPlanList-create-template-button'}
			>
				{t('actions.createTemplate')}
			</CustomButton>
			<FilterSelectionBar
				setStatusFilterSelected={setStatusFilterSelected}
				searchValue={searchValue}
				setSearchValue={setSearchValue}
				allStatus={Object.values(WorkplanCurrentStatus)}
			/>
		</div>
	);

	const newWorkPlan = showRightPanelList && (
		<WorkPlanForm
			action={actionWorkplanList}
			selectedWorkPlan={''}
			currentJob={''}
			closeForm={closeRightPanel}
			refreshAdmin={refreshAdmin}
			settingList={settingsList}
		/>
	);

	const chipStatus = (status) => {
		let color = '';
		let label = '';
		let border = '';
		switch (status) {
			case WorkplanCurrentStatus.Active:
				color = 'green';
				border = 'white';
				label = 'workplanCurrentStatus.active';
				break;
			case WorkplanCurrentStatus.Paused:
				color = 'yellow';
				border = 'white';
				label = 'workplanCurrentStatus.paused';
				break;
			case WorkplanCurrentStatus.Stopped:
				color = 'red';
				border = 'white';
				label = 'workplanCurrentStatus.stopped';
				break;
			case WorkplanCurrentStatus.Scheduled:
				color = '#CFE0FC'
				border = '#A0C2F9';
				label = 'workplanCurrentStatus.scheduled';
				break;
			case WorkplanCurrentStatus.Draft:
				color = 'white';
				border = 'gray';
				label = 'workplanCurrentStatus.draft';
				break;
			default:
				color = 'white';
				border = 'gray';
				label = 'Unknown';
				break;
		}
		return (
			<CustomToolTip
				enterDelay={250}
				titletext={t(label)}
				jsx={
					<div className='workPlanList-status-chip' style={{ backgroundColor: color, border: `1px solid ${border}` }} />
				}
			/>
		);
	};

	const genOrgPathField = (OrgPaths = [], containerElement) => {
		if (OrgPaths === null) {
			return "";
		}
		else if (OrgPaths.length === 1) {
			return <CustomToolTip titletext={OrgPaths[0].orgPath} jsx={<div className="name">{genOrgPath(OrgPaths[0].orgPath, containerElement)}</div>} />;
		} else if (OrgPaths.length > 1) {
			let jobList = <div>{OrgPaths.map((orgPath, index) => { return <div key={"jobList__orgPath" + index} >{orgPath.orgPath}</div> })}</div>
			return <CustomToolTip titletext={jobList} jsx={<div className="name" > Multiple Jobs Selected</div>} />;
		}
		else if (OrgPaths.length === 0) {
			return "";
		}
	};

	const buttonsHandler = (e, action, workplan) => {
		e.stopPropagation();
		e.preventDefault();
		switch (action) {
			case 'EditWorkplan':
			case 'DuplicateWorkplan':
				updateActionWorkplanList(action);
				updateSelectedWorkPlan(workplan);
				updateShowRightPanelList(true);
				break;
			default:
				break;
		}
	};

	const handleNameClick = (row) => (
		updateSelectedWorkPlan(row)
	);
	const snackBar = snackbar.openSnackbar ? (
		<Snackbar
			type={snackbar.typeSnackbar}
			message={snackbar.messageSnackbar}
			open={snackbar.openSnackbar}
			closeSnackbar={closeSnackbar}
			bodyStyle={{ whiteSpace: 'pre-line' }}
		/>) : '';

	return (
		<React.Fragment>
			{header}
			<Paper elevation={2} style={{ padding: '0 10px' }} ref={ref}>
				<WorkPlanListTable
					sortValues={sortValues}
					setSortValues={setSortValues}
					height={height}
					filteredWorkPlans={filteredWorkPlans}
					handleNameClick={handleNameClick}
					chipStatus={chipStatus}
					t={t}
					genOrgPathField={genOrgPathField}
					buttonsHandler={buttonsHandler}
					openDeleteDialog={(id, name) => {
						setShowDeleteDialog(true);
						setWorkplanIdToDelete(id);
						setWorkplanNameToDelete(name);
					}}
				/>
			</Paper>
			<SimpleDialog
				open={showDeleteDialog}
				title={t('form.delete')}
				contentText={t('form.deleteRequestConfirmation') + workplanNameToDelete + "?"}
				acceptText={t('yes')}
				rejectText={t('no')}
				submit={deleteWorkPlan}
				cancelDelete={cancelAction}
			/>
			{snackBar}
			<SideBar
				handleDrawerClose={() => { updateSelectedWorkPlan(''); updateShowRightPanelList(false) }}
				open={showRightPanelList}
				className={classes.SideBar}
				title={sideBarTitle.title}
				icon={sideBarTitle.icon}
			>
				{newWorkPlan}
			</SideBar>
		</React.Fragment>
	);
};

const mapStateToProps = state => {
	return {
		MAINworkPlans: state.MAINworkPlans,
		httpOptions: state.httpOptions,
		spinnerShow: state.spinnerShow,
		snackbar: state.snackbar,
		selectedWorkPlan: state.selectedWorkPlan,
		actionWorkplanList: state.actionWorkplanList,
		showRightPanelList: state.showRightPanelList,
		settingsList: state.settingsList
	};
};

const mapDispatchToProps = {
	updateSpinnerShow,
	updateMAINworkPlans,
	updateSelectedWorkPlan,
	updateUrlKronos,
	updateSettingsList,
	updateActionWorkplanList,
	updateSnackbar,
	updateShowRightPanelList,
};

export default connect(mapStateToProps, mapDispatchToProps)(translate('workplanManager')(withStyles(styles)(WorkPlanList)));
